<div class="row align-items-end text-center">
    @for (preset of options; track preset) {
        <div class="col-4 mb-3">
            <button kui-button color="secondary" size="lg" class="w-100" [title]="preset.title" (click)="selectPreset(preset)">
                @if (preset.iconType === "icon") {
                    <kui-icon [name]="preset.iconName" size="lg"></kui-icon>
                }
                @if (preset.iconType === "svg") {
                    <span [innerHTML]="getPresetIcon(preset.iconName)"></span>
                }
            </button>
            <div class="mt-1">{{ preset.title }}</div>
        </div>
    }
</div>
